import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import memoize from "lodash.memoize";

const slice = createSlice({
  name: "operationResults",
  initialState: {
    items: [],
  },
  reducers: {
    operationResultAdded: (state, action) => {
      const { requestId, successMessage, errorMessage } = action.payload;
      state.items.push({
        requestId: requestId ?? null,
        successMessage: successMessage ?? null,
        errorMessage: errorMessage ?? null,
      });
    },
    operationResultClearedByRequestId: (state, action) => {
      const requestId = action.payload;
      state.items = state.items.filter((item) => item.requestId !== requestId);
    },
    operationResultsCleared: (state) => {
      state.items = [];
    },
  },
});

export const {
  operationResultAdded,
  operationResultClearedByRequestId,
  operationResultsCleared,
} = slice.actions;
export default slice.reducer;

export const getOperationResultItems = createSelector(
  (state) => state.ui.operationResults,
  (operationResults) =>
    memoize(() => {
      return operationResults?.items ?? [];
    })
);

export const getOperationResultByRequestId = createSelector(
  (state) => state.ui.operationResults,
  (operationResults) =>
    memoize((requestId) => {
      const items = operationResults?.items ?? [];
      return items.find((item) => item.requestId === requestId) ?? null;
    })
);
